import { ROUTES } from 'routes/_definition';
import React, { useCallback, useRef } from 'react';
import { usePathParams } from 'routes/routeUtils';
import ShowcaseToShowcaseTransition from 'common/features/ShowcaseTransition/ShowcaseToShowcaseTransition';
import ArtShowcase from 'stacks/ShowcaseNewV2/views/Showcase';
import ArtistProfileArtworksDataManager, {
  useArtistProfileArtworksDataManager,
} from 'stacks/ArtistProfile/ArtistProfileArtworks/components/ArtistProfileArtworksDataManager';
import useAppSelector from 'common/hooks/useAppSelector';
import ShowcaseReelContent from 'stacks/ArtistProfile/ArtistProfileArtworks/views/ShowcaseReelContent';
import useHandleSlugFromCustomDomainOrRoute from 'stacks/ShowcaseNewV2/hooks/useHandleSlugFromCustomDomainOrRoute';
import { useGetNextArtistProfileArtwork } from 'stacks/ArtistProfile/hooks/useGetNextArtistProfileArtwork';
import { useGetShowcaseTransitionProps } from 'common/features/ShowcaseTransition/useGetShowcaseTransitionProps';
import { useCustomDomain } from 'common/hooks/useCustomDomain';

const ArtistShowcasePage: React.FC = () => {
  const customDomainHandle = useCustomDomain();
  const { artistHandle, artworkSlug } = usePathParams<ROUTES.ARTIST_HANDLE_SHOWCASE_ARTWORK_SLUG>();
  const { transitionKey, artworkId, fileId, showcasePreviewSrc } = useGetShowcaseTransitionProps(
    artistHandle ?? customDomainHandle ?? '',
    artworkSlug ?? ''
  );
  const routeParams = useHandleSlugFromCustomDomainOrRoute();
  const currentDetailedStatus = useAppSelector((store) => store.artistProfileArtworks.list.data.detailed.status);

  const loadedFirstPage = useRef(false);
  loadedFirstPage.current = loadedFirstPage.current || ['FINISHED', 'IDLE'].includes(currentDetailedStatus);
  const UseArtistProfileArtworksDataManager: React.FC = useCallback(() => {
    useArtistProfileArtworksDataManager();
    return null;
  }, []);

  const hasMoreArtworks = useAppSelector((store) => store.artistProfileArtworks.list.data.detailed.values.length > 1);
  const { nextArtworkFound, previousArtworkFound } = useGetNextArtistProfileArtwork(artworkId);

  return (
    <ShowcaseToShowcaseTransition transitionKey={transitionKey}>
      <ArtShowcase
        artworkId={artworkId}
        primaryImageMetadataId={fileId}
        previewSrc={showcasePreviewSrc}
        hasMoreArtworks={hasMoreArtworks}
        nextArtwork={nextArtworkFound}
        previousArtwork={previousArtworkFound}
        {...routeParams}
      >
        {/* Content for More artworks dialog */}
        <ArtistProfileArtworksDataManager autofetchUntilId={artworkId} hideFooter>
          <ShowcaseReelContent />
        </ArtistProfileArtworksDataManager>
      </ArtShowcase>
      {!loadedFirstPage.current && <UseArtistProfileArtworksDataManager />}
    </ShowcaseToShowcaseTransition>
  );
};
export default ArtistShowcasePage;
